import { useQuery } from "@tanstack/react-query";
import categoriesService from "services/admin/categoriesService";

export const useGetCategories = (queryParams = {}) => {
  return useQuery({
    queryKey: ["categories", queryParams],
    queryFn: async () => {
      const response = await categoriesService.getAll(queryParams);
      return response.data;
    },
  });
};
